import { render } from "./SupplierIndex.vue?vue&type=template&id=d6ab807e&scoped=true"
import script from "./SupplierIndex.vue?vue&type=script&lang=js"
export * from "./SupplierIndex.vue?vue&type=script&lang=js"

import "./SupplierIndex.vue?vue&type=style&index=0&id=d6ab807e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6ab807e"]])

export default __exports__